import BetRowSkeleton from '@/pages/portfolio/my-bets/bet-row/BetRowSkeleton'

const BetListTableLoadingBody = ({ rows = 3, activeOrPast = 'active', columnCount }) =>
  Array.from({ length: rows }).map((_, index) => (
    <BetRowSkeleton key={`bet-row-skeleton-${index}`} activeOrPast={activeOrPast} columnCount={columnCount} />
  ))

export default BetListTableLoadingBody
